import CompactInventoryCard from "@Components/CompactInventoryCard";
import { useEffect, useState } from "react";
import classes from "./BudgetFriendlySection.module.scss";
import SectionContainer from "@Pages/PropertyPage/components/SectionContainer";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import HorizontalScroll from "@Components/HorizontalScroll";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";
import { getInventoryBudgetFriendlyById } from "./helper";

const SSR_LIMIT = 5;

interface BudgetFriendlyPropertiesProps {
  gtagEventCategory: string;
  isDesktop: boolean;
}

const BudgetFriendlyProperties = ({
  gtagEventCategory,
  isDesktop,
}: BudgetFriendlyPropertiesProps) => {
  const { inventory, userCurrency, userLanguage, ssrBudgetFriendly } = useSelector(
    ({ propertyPageData, appData }: AppState) => ({
      id: propertyPageData?.data?.id,
      inventory: propertyPageData.data,
      userCurrency: appData.userCurrency,
      userLanguage: appData.userLanguage,
      ssrBudgetFriendly: propertyPageData.budgetFriendlyProperties,
    }),
    shallowEqual,
  );
  const { t } = useTranslationHook();
  const [listings, setListings] = useState<any>(
    ssrBudgetFriendly ? ssrBudgetFriendly.slice(0, SSR_LIMIT) : [],
  );
  const getListings = async () => {
    const budgetFriendlyData = await getInventoryBudgetFriendlyById({
      inventory_id: inventory?.id,
      userCurrency,
      lang: userLanguage,
    });
    if (budgetFriendlyData && budgetFriendlyData.length > 0) {
      setListings(budgetFriendlyData);
    } else if (!ssrBudgetFriendly || ssrBudgetFriendly.length === 0) {
      const event = new Event("navigation_section_removed");
      window.dispatchEvent(event);
      setListings([]);
    }
  };

  useEffect(() => {
    // Skip client-side fetch if SSR already provided budget friendly data
    if (ssrBudgetFriendly && ssrBudgetFriendly.length > 0) return;
    getListings();
  }, [inventory?.id, userLanguage]);

  const budgetFriendlyHeadline = t("Budget Friendly Properties");

  return (
    <>
      {listings?.length > 0 && (
        <SectionContainer
          title={budgetFriendlyHeadline}
          id="budget_friendly_properties"
          className={formatClassNames(
            classes.container,
            isDesktop ? classes.desktop : "",
            isDesktop ? classes.bottomMargin : "",
          )}
          isDesktop={isDesktop}
          showTitleLine
          headingLevel={2}
        >
          <HorizontalScroll
            className={formatClassNames(
              classes.scrollContainer,
              isDesktop ? classes.scrollContainerDesktop : "",
            )}
            showControls={isDesktop}
          >
            {listings.map((item: any) => (
              <CompactInventoryCard
                item={item}
                key={item.id}
                isRequestActive={false}
                isDesktop={isDesktop}
                showIcons
                gtagEventAction="clicked_budget_friendly_properties"
                gtagEventCategory={gtagEventCategory}
                screenName={APP_PAGE.PROPERTY}
              />
            ))}
          </HorizontalScroll>
        </SectionContainer>
      )}
    </>
  );
};

export default wrapperHOC(BudgetFriendlyProperties, {
  componentName: "BudgetFriendlyProperties-SearchPage",
  showForChina: true,
  showForWhiteLable: true,
});
